'use client';
import { useContext } from 'react';
import { AppContext } from '../../contexts/AppContext';

export const useCoursesLink = (): string | null => {
    const { context } = useContext(AppContext);
    switch (context) {
        case 'marketplace':
            return `/courses`;
        case 'minisite':
            return null;
        case 'embed':
            return null;
    }
};
